var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "415", height: "416", viewBox: "0 0 415 416", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("rect", { x: "-1", width: "416", height: "416", rx: "10", fill: "#fff" }),
    React.createElement("path", { d: "M54 385.824C54 325.722 102.722 277 162.824 277H251.176C311.278 277 360 325.722 360 385.824C360 387.026 359.026 388 357.824 388H56.1765C54.9744 388 54 387.026 54 385.824Z", fill: "#ECECEC" }),
    React.createElement("circle", { cx: "207", cy: "178", r: "80", fill: "#ECECEC" })
  );
});